//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    ie_objectfit_fallback,
    ie_objectfit_fallback_container
} from "../../regular/fallbacks.js";

export default {
    props: {
        id: {},
        object: {}
    },
    data: function() {
        return {
            post: {
                post_type: {}
            },
            rest_options: rest_options
        };
    },
    mounted: function() {
        if (!this.object) {
            this.get_teaser_post(this.id);
        } else {
            this.post = this.object;
        }
    },
    updated: function() {
        ie_objectfit_fallback_container(this.$refs.search_teaser_image);
    },
    methods: {
        relocate() {
            window.location.href = this.article.permalink;
        },
        get_teaser_post: function(id) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(
                        "/wp-json/vtv/v1/search/get_post?id=" +
                        id +
                        "&lang=" +
                        rest_options.lang
                    )
                    .then(response => {
                        this.post = response.body;
                        resolve(response);
                    });
            });
        }
    }
};



// WEBPACK FOOTER //
// ./js/vue/search/search-teaser.vue